import React from "react";
import Card from "@mui/material/Card";
import { CardHeader, Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { getTimeFromNow } from "../../../functions/time";
import { sanitizeAllowed } from "../../../functions/html";
import AttachmentList from "../../../components/AttachmentList/AttachmentList";
import DocumentLayout from "../../../components/Layouts/DocumentLayout";
import MessagesSection from "./MessagesSection";
import { getCardHeader } from "./ticketDetailUtils";
import type { CurrentTicketType } from "../../../modules/ticket/ticketDetail/currentTicket/currentTicketSlice";

interface CreatedAtProps {
  item: {
    createdAt?: string;
    updatedAt?: string;
  };
}

const CreatedAt: React.FC<CreatedAtProps> = ({ item }) => (
  <Typography component="p" color="textSecondary">
    {item.updatedAt || item.createdAt}
  </Typography>
);

interface TicketDetailItemPrivateProps {
  item: CurrentTicketType;
}

const TicketDetailItemPrivate: React.FC<TicketDetailItemPrivateProps> = ({
  item,
}) => {
  const attachments = item.attachments || [];
  const cardHeader = getCardHeader(item, attachments);

  return (
    <DocumentLayout>
      <Card>
        <CardHeader title={cardHeader.title} subheader={cardHeader.subheader} />

        {/* attachments section */}
        {attachments && attachments.length > 0 && (
          <>
            <Divider />
            <AttachmentList attachments={attachments} />
          </>
        )}

        {item.body && (
          <>
            <Divider />
            <CardContent>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeAllowed(item.body),
                }}
              />
            </CardContent>
          </>
        )}

        <CardContent>
          <CreatedAt
            item={{
              createdAt: item.createdAt
                ? getTimeFromNow(item.createdAt)
                : undefined,
              updatedAt: item.updatedAt
                ? getTimeFromNow(item.updatedAt)
                : undefined,
            }}
          />
        </CardContent>

        {/* messages section */}
        <MessagesSection />
      </Card>
    </DocumentLayout>
  );
};

export default TicketDetailItemPrivate;
